export default __webpack_public_path__ + "static/media/houston_super_neighborhoods_official.dd5c04cd.geojson";